<template>
  <a class="cursor-pointer font-bold" @click="params.colDef.CellRendererParams.goToGradebook(params.data)">Result</a>
</template>
<script>
export default {
  name: 'GoToGradebookCell'
}
</script>